<template>
	<div class="c-log">
		<p class="c-log-info">
            {{date.replace(/:\d{2}$/, '')}} 由 <span>{{person}}</span> {{action}} <slot name="tag"></slot>
            <template v-if="dispatch_id && auth('b_aftersale_order_dispatch_log')">
                <c-link @click="globalDialog('afterSaleOrderDispatchLog', {props: {id: order_id,dispatch_id:dispatch_id}})">派单日志</c-link>
            </template>
        </p>
		<div v-if="$slots.remark || $slots.image" class="c-log-content">
			<div v-if="$slots.remark" class="c-log-remark"><slot name="remark"></slot></div>
			<div v-if="$slots.image" class="c-log-image flex-wrap"><slot name="image"></slot></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'logItem',

		props: {
			date: String,
			person: String,
			action: String,
            order_id: Number,       //工单ID
            dispatch_id: Number     //系统派单ID
		}
	}
</script>

<style lang="stylus" scoped>
	.c-log {
		margin: 0 10px 10px;

		&-info {
			margin: 0 10px;
			line-height: 20px;
			font-size: 14px;
			color: #666;

			span {
				color: var(--color-main);
			}
		}

		&-content {
			border-radius: 2px;
			padding: 8px 12px;
			margin-top: 5px;
			background: #F9F9F9;
		}

		&-remark {
			overflow: hidden;

			>>> .c-field {
				font-size: 13px;
				color: #666;
			}

			+ .log-image {
				margin-top: 5px;
			}
		}

		&-image {
			gap: .24rem;
			margin-top: 5px;
			
			>>> .c-file-media {
				border: none;
			}
		}
	}
</style>
